export default "__VITE_ASSET__c55af0a8__"